import { render, staticRenderFns } from "./MaliciousCutsDrawer.vue?vue&type=template&id=485d8c30"
import script from "./MaliciousCutsDrawer.vue?vue&type=script&lang=js"
export * from "./MaliciousCutsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports